<template>
  <div>
    <div class="biggestBox">
      <ul>
        <!-- data-type=0 隐藏删除按钮 data-type=1 显示删除按钮 -->
        <li class="li_vessel" v-for="(item,index) in content " data-type="0" :key="index">
          <!-- "touchstart" 当手指触摸屏幕时候触发  "touchend"  当手指从屏幕上离开的时候触发  "capture" 用于事件捕获-->
          <v-card @touchstart.capture="touchStart" @touchend.capture="touchEnd" @click="oneself(item)" :style="cardStyle">
            <div class="contant">
              <div class="rightBox">
                <div>{{item.title}}</div>
                <div>{{item.content}}</div>
<!--                <div>{{item.faddish}}</div>-->
                <div>{{getShowData(item.c_date)}}</div>
              </div>
            </div>
          </v-card>
          <v-card class="removeBtn" @click="remove" :data-index="index" style="height: 10vh">删除</v-card>
        </li>
      </ul>
    </div>

    <el-button class="add-button" type="primary" icon="el-icon-plus" circle @click="handleClick"></el-button>

    <el-dialog
            :title="title"
            :visible.sync="centerDialogVisible"
            fullscreen
            center
    >
      <el-form ref="dataForm" :model="memo">
        <el-row>
          <el-col :span="23">
            <el-form-item label="标签" :label-width="formLabelWidth" prop="title">
              <el-input v-model="memo.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth" prop="summary">
              <el-input  type="textarea" v-model="memo.content"  :rows="rows"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {getMemoList, AddMemo, DelMemo} from "../../api";

  export default {
    name: "index",
    data() {
      return {
        content: [],
        startX: 0, //滑动开始
        endX: 0, //滑动结束
        cardStyle: {
          height: "10vh"
        },
        formLabelWidth: "50px",
        centerDialogVisible: false,
        memo:{
          title: "",
          content: "",
          c_date: ""
        },
        minRows: 15,
        title: "备忘录"
      };
    },
    created() {
      this.loadDate();
    },
    computed:{
      rows() {
        if ( this.memo.content != null ) {
          const content = this.memo.content.split('\n');
          let le = content.length;
          content.forEach(item => {
            le += Math.floor(item.length / 21);
          });
          return Math.min(Math.max(this.minRows, le), 30); // 至少保持minRows行
        }else{
          return this.minRows
        }

      }
    },
    methods: {
      // 向左滑动出现删除按钮时，点击商品信息区域取消删除
      loadDate(){
        getMemoList().then(res => {
          if (res.data.length > 0){
            this.content = res.data;
          }
        })
      },
      submit(){
        var date = new Date();
        this.del = "";
        this.user = "";
        this.memo.c_date = this.getShowData(date);
        AddMemo(this.memo).then(res => {
          this.memo = {};
          this.centerDialogVisible = false;
          this.loadDate();
        })
      },
      oneself(item) {
        if (this.checkSlide()) {
          this.restSlide();
        } else {
          // 点击商品信息弹出弹框
          // alert("hello Word!");
          this.memo = item;
          this.centerDialogVisible = true;
        }
      },
      //滑动开始
      touchStart(e) {
        // 记录初始位置
        this.startX = e.touches[0].clientX;
      },
      //滑动结束
      touchEnd(e) {
        // 当前滑动的父级元素
        let parentElement = e.currentTarget.parentElement;
        // 记录结束位置
        this.endX = e.changedTouches[0].clientX;
        // 左滑大于30距离删除出现
        if (parentElement.dataset.type == 0 && this.startX - this.endX > 30) {
          this.restSlide();
          parentElement.dataset.type = 1;
        }
        // 右滑
        if (parentElement.dataset.type == 1 && this.startX - this.endX < -30) {
          this.restSlide();
          parentElement.dataset.type = 0;
        }
        this.startX = 0;
        this.endX = 0;
      },
      //判断当前是否有滑块处于滑动状态
      checkSlide() {
        let listItems = document.querySelectorAll(".li_vessel");
        for (let i = 0; i < listItems.length; i++) {
          if (listItems[i].dataset.type == 1) {
            return true;
          }
        }
        return false;
      },
      //复位滑动状态
      restSlide() {
        let listItems = document.querySelectorAll(".li_vessel");
        // 复位
        for (let i = 0; i < listItems.length; i++) {
          listItems[i].dataset.type = 0;
        }
      },
      getShowData(value){
        const dateTime = new Date(value);
        const year = dateTime.getFullYear();
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const day = dateTime.getDate().toString().padStart(2, '0');
        const hours = dateTime.getHours().toString().padStart(2, '0');
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        const seconds = dateTime.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      //删除数据信息
      remove(e) {
        // 当前索引值
        let index = e.currentTarget.dataset.index;
        // 复位
        this.restSlide();

        DelMemo(this.content[index].id).then(res=>{
          this.content.splice(index, 1);
        })
        // 删除数组lists中一个数据
      },
      handleClick(){
        this.memo = {};
        this.centerDialogVisible = true;
      }
    },
  };
</script>

<style>
  * {
    /* 消除默认内外边距 */
    margin: 0;
    padding: 0;
  }
  body {
    background: rgb(246, 245, 250);
  }
  .biggestBox {
    overflow: hidden; /*超出部分隐藏*/
  }
  ul {
    /* 消除 ul 默认样式 */
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .li_vessel {
    /* 全部样式 0.2秒 缓动*/
    transition: all 0.2s;
  }
  /* =0隐藏 */
  .li_vessel[data-type="0"] {
    transform: translate3d(0, 0, 0);
  }
  /* =1显示 */
  .li_vessel[data-type="1"] {
    /* -64px 设置的越大可以左滑的距离越远，最好与下面删除按钮的宽度以及定位的距离设置一样的值*/
    transform: translate3d(-64px, 0, 0);
  }
  /* 删除按钮 */
  .li_vessel .removeBtn {
    width: 64px;
    height: 103px;
    background: #ff4949;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 22px;
    position: absolute;
    top: 0px;
    right: -64px;
    line-height: 103px;
    text-align: center;
    border-radius: 2px;
  }
  /* 左边的图片样式 */
  .contant {
    overflow: hidden; /*消除图片带来的浮动*/
    padding: 10px;
    background: #ffffff;
  }

  .contant .image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    float: left;
  }
  /* 右边的文字信息样式 */
  .rightBox {
    overflow: hidden;
    padding-left: 8px;
    width: 46vh;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .rightBox div:first-child {
    font-weight: bold;
  }
  .rightBox div:nth-child(2) {
    margin-top: 4px;
    font-size: 14px;
  }
  /*.rightBox div:nth-child(3) {*/
  /*  width: 24px;*/
  /*  background: rgb(219, 91, 113);*/
  /*  color: white;*/
  /*  font-size: 12px;*/
  /*  text-align: center;*/
  /*  padding: 2px 4px 2px 4px;*/
  /*  margin-left: auto;*/
  /*}*/
  .rightBox div:last-child {
    color: #b9b9b9;
    font-size: 10px;
    font-weight: bold;
    position: fixed;
    bottom: 5px;
    right: 5px;
  }

  .add-button {
    position: fixed;
    bottom: 20px; /* 距离底部的距离 */
    right: 20px; /* 距离右侧的距离 */
  }
</style>